import { Box, ListItem } from "@mui/material";
import { CloseIcon, DoneIcon } from "Components/Shared/Icons";

type Props = {
  text: string;
  isCompleted: boolean;
};

export const TodoListItem = ({ text, isCompleted }: Props) => (
  <ListItem>
    <Box
      display="flex"
      gap={3}
      alignItems="center"
      color={({ palette }) => (isCompleted ? "green" : palette.text.secondary)}
    >
      {isCompleted ? (
        <DoneIcon height={16} width={16} />
      ) : (
        <CloseIcon height={16} width={16} />
      )}
      {text}
    </Box>
  </ListItem>
);
